import { useContext, useEffect, useState } from "react";
import { MdPhoneInTalk } from "react-icons/md";
import { api } from "../../..";
import { app } from "@microsoft/teams-js";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { PusherContext } from "../../../PusherContextProvider";

function LiveQueue() {
	app.initialize()
	const [liveQueueData, setLiveQueueData] = useState([]);
	const { id } = useParams();
	const { t } = useTranslation();
	const pusher = useContext(PusherContext)

	useEffect(() => {
		if(api.accessToken && pusher) {
			pusher.pushOnMessageListener('Queue', (q: any) => {
				if (q?.queue.id === id) {
					setLiveQueueData(q.callers);
				}
			})
		}
		// eslint-disable-next-line
	}, [])

	// Pick Up queue Call
	const pickCall = (queue:any) => {
		if(queue['pbx_queue_id'] && queue['id']) {
			api.calls.queue.callers.pickup(queue['pbx_queue_id'], queue['id']);
		}
	}

	return <div className="callout">
		<div className="live-queue">
			<div className="row">
				<div className="small-12 medium-12 large-12 columns">
					<b>{t('live_queue')}</b>
				</div>
			</div>
			<div className="row live-queue-data">
				<div className="small-12 medium-12 large-12 columns">
					<table className="unstriped">
						<thead>
							<tr>
								<th>
									<b>{t('number')}</b>
								</th>
								<th>
									<b>{t('pick_call')}</b>
								</th>
							</tr>
						</thead>
						<tbody>
							{
								liveQueueData.length !== 0
								?
									liveQueueData.map((q) => {
										if (q['pbx_queue_id'] === id) {
											return <tr key={ q['id'] }>
												<td>{ q['number'] }</td>
												<td>
													<MdPhoneInTalk
														onClick={() => pickCall(q)}
														className="phone-talk"
														title={t('pick_call')}
													/>
												</td>
											</tr>
										}
									})
								:
									<tr>
										<td className="center" colSpan={2}>{t('no_data_found')}</td>
									</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
}

export default LiveQueue;
